import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Dashboard from '@/views/dashboard/dashboard'
import Login from '@/views/Login'
import BaseTable from '@/views/basetable'
import BaseForm from '@/views/baseform'
import QuartzList from '@/views/quartz/quartzList'
import ModuleConfig from '@/views/pageconfig/moduleConfig'
import IndexNavList from '@/views/pageconfig/indexNavList'
import IndexItemList from '@/views/pageconfig/indexItemList'
import pageLinkList from '@/views/pageconfig/pageLinkList'
import pageDetail from '@/views/pageconfig/pageLinkDetail'
import Dictionary from '@/views/dictionary/dictionary'
import System from '@/views/system/system'
import ImageList from '@/views/image/imageList'
import CashBath from '@/views/cash/cashBath'
import CashBathDetail from '@/views/cash/cashBathDetail'
import cashSendLog from '@/views/cash/cashSendLog'
import messageConfig from '@/views/wechat/messageConfig'
import promotionList from '@/views/promotion/promotionList'
import promotionOrder from '@/views/promotion/promotionOrder'
import scrollpic from '@/views/scrollpic/scrollpic'
import scrollpicDetail from '@/views/scrollpic/scrollpicDetail'
import sysuser from '@/views/sys/user'
import sysresource from '@/views/sys/resource'
import sysresourcegroup from '@/views/sys/resourcegroup'
import sysrole from '@/views/sys/role'
import password from '@/views/sys/password'
import ProductList from '@/views/sales/productList'
import ProductDetail from '@/views/editDetail/productdetail'
import PromotionDetail from '@/views/editDetail/promotiondetail'
import productPrice from '@/views/sales/productPrice'
import ProductDic from '@/views/picture/picture_tab'
import GroupList from '@/views/sales/groupList'
import GroupDetail from '@/views/editDetail/groupdetail'
import cashcreaterule from '@/views/cash/cashcreaterule'
import wechatKeywordList from '@/views/wechat/wechatKeywordList'
import wechatKeywordContent from '@/views/wechat/wechatKeywordContent'
import wechatKeywordDetail from '@/views/wechat/wechatKeywordDetail'
import wechatmediaList from '@/views/wechat/wechatmediaList'
import wechatBaseList from '@/views/wechat/wechatBaseList'
import wechatMenu from '@/views/wechat/wechatMenu'
import messageLog from '@/views/wechat/messageLog'
import messageTotalLog from '@/views/wechat/messageTotalLog'
import miniScheme from '@/views/urlscheme/miniScheme'
import miniCard from '@/views/wechat/miniCard'
import shortlink from '@/views/shortlink/shortlink'
import miniLink from '@/views/shortlink/miniLink'
import adSource from '@/views/wechat/adSource'
import wechatGroupList from '@/views/wechat/wechatGroupList'
import staffConfig from '@/views/wechat/staffConfig'
import platform from '@/views/system/platform'
import regular from '@/views/sales/regular'
import productrelevance from '@/views/sales/productrelevance'
import wechatTemplateMessageList from '@/views/wechat/wechatTemplateMessageList'
import wechatTemplateMessageContent from '@/views/wechat/wechatTemplateMessageContent'
import fullcut from '@/views/sales/fullcut'
import fullcutDetail from '@/views/sales/fullcutDetail'
import free from '@/views/sales/free'
import freeEdit from "@/components/sales/freeEdit";
import shoppingRuleList from '@/views/sales/shoppingRuleList'
import vipDay from '@/views/vip/vipDay'
import vipConditionList from '@/views/vip/vipConditionList'
import vipReward from '@/views/vip/vipReward'
import vipRight from '@/views/vip/vipRight'
import vipTask from '@/views/vip/vipTask'
import vipTaskReward from '@/views/vip/vipTaskReward'
import vipDaySendLog from '@/views/vip/vipDaySendLog'
import discountRange from '@/views/vip/vipDiscountRange'
import mallEvaluate from '@/views/mallevaluate/mallEvaluate'
import mallEvaluateStatistics from '@/views/mallevaluate/mallEvaluateStatistics'
import mallFreight from '@/views/deliver/mallFreight'
import collage from '@/views/collage/collage'
import productList from '@/views/collage/productList'
import crowdCoupon from '@/views/crowd/productCoupon'
import collageDiscount from '@/views/collage/collageDiscount'
import activeManagement from '@/views/active/activeManagement'
import activeQrMangement from '@/views/active/activeQrMangement'
import activeIndex from '@/views/active/activeIndex'
import activeProperty from '@/views/active/activeProperty'
import nps from '@/views/active/nps'
import activeCoupon from '@/views/coupon/coupon_tab'
import salesNum from '@/views/salesManage/salesNum'
import activeRule from '@/views/active/activeRule'
import grouponConfig from '@/views/groupon/grouponConfig'
import grouponList from '@/views/order/groupOrder'
import invite from '@/views/fit/invite'
import joinList from '@/views/fit/joinList'
import crowd from '@/views/crowd/crowdProduct'
import crowdOrder from '@/views/crowd/crowdOrder'
import activeReserve from '@/views/active/activeReserve'
import inviteGiftPropert from '@/views/active/inviteGiftPropertyList'

import UnsyncOrders from '@/views/order/UnsyncOrders'
import UnsyncedOMSOrders from '@/views/order/UnsyncedOMSOrders'
import orderRefundFailRecord from '@/views/order/orderRefundFailRecord'
import outStock from '@/views/order/outStock'
import userSystem from '@/views/userSystem/userSystem'
import userInfo from '@/views/userSystem/userInfo'
import userSystemContent from '@/views/userSystem/userSystemContent'
import GiftCardBatch from '@/views/giftCard/GiftCardBatch'
import BalanceCardBatch from '@/views/giftCard/BalanceCardBatch'
import CouponCardBatch from '@/views/giftCard/CouponCardBatch'
import BalanceInventoryRecords from '@/views/giftCard/BalanceInventoryRecords'
import StorageCard from '@/views/storage/storageCard'
import SumDaily from '@/views/storage/SumDaily'
import queryOrder from '@/views/order/queryOrder'
import shipOrder from '@/views/order/shipOrder'
import youShuOrder from '@/views/order/youShuOrder'
import orderBill from '@/views/bill/orderBill'

import smsSend from '@/views/sms/smsSend'
import baseApp from '@/views/sms/baseApp'
import template from '@/views/sms/template'
import messageGroup from '@/views/sms/group'
import task from '@/views/sms/task'
import groupRule from '@/views/sms/groupRule'
import limitMessage from '@/views/sms/limitMessage'
import tag from '@/views/sms/tag'
import tagTypeRule from '@/views/sms/tagTypeRule'
import messageBlackList from '@/views/blackList/messageBlackList'
import messageBlackEdit from '@/views/blackList/messageBlackEdit'


import TaskEdit from '@/views/push/TaskEdit'
import wordsEdit from '@/views/distribution/wordsEdit'
import wordsList from '@/views/distribution/wordsList'
// import priceList from '@/views/sales/priceList'
//import prizeList from '@/views/cooperative/prizelist'
import allList from '@/views/cooperative/allList'
import userInterview from '@/views/cooperative/userInterview'
import growth from '@/views/cooperative/growth'
import cooperate from '@/views/cooperative/cooperate'
import cooperatePersonal from '@/views/cooperative/cooperatePersonal'
import quarterKpi from '@/views/cooperative/quarterkpi'
import monthReplay from '@/views/cooperative/monthreplay'
import weekAfterWeek from '@/views/cooperative/weekafterweek'
import interviewInvitation from '@/views/cooperative/interviewinvitation'
import setGrowthInterview from '@/views/cooperative/setGrowthInterview'

import QuestionClasses from '@/views/cooperative-manage/QuestionClasses'
import Periods from '@/views/cooperative-manage/Periods'

import CardBatch from '@/views/prepay/CardBatch'
import CardBatch2 from '@/views/prepay/CardBatch2'
import CardItem from '@/views/prepay/CardItem'
import CardBatchFree from '@/views/prepay/CardBatchFree'
import cardOrderPlanLog from '@/views/order/cardOrderPlanLog'
import cardOrderPlan from '@/views/order/cardOrderPlan'
import shareList from '@/views/distribution/shareList'
import orderRefundPayDownload from '@/views/bill/orderRefundPayDownload'
import distributorGroup from '@/views/distribution/distributorGroup'
import distributor from '@/views/distribution/distributor'
import distributorRelation from '@/views/distribution/distributorRelation'
import distributionOrder from '@/views/distribution/distributionOrder'
import distributorItem from '@/views/distribution/distributorItem'
import distributionMedia from '@/views/distribution/media'
import distributorMedia from '@/views/distribution/mediaStaff'
import siYuLink from '@/views/distribution/siYuLink'
import distributorLink from '@/views/distribution/distributorLink'
import qyTag from '@/views/distribution/tag'
import corpTagGroup from '@/views/distribution/tagGroup'
import corpTagRuleGroup from '@/views/distribution/tagRuleGroup'
import tagRule from '@/views/distribution/tagRule'

import offLineShop from '@/views/distribution/offLineShop'
import salePersonInfo from '@/views/distribution/salePersonInfo'

import qrcode from '@/views/qrcode/qrcode'
import subqrcode from '@/views/qrcode/subQrcode'

import accesslogallactions from '@/views/monitor/AccessLogAllActions'
import accesslogsavglist from '@/views/monitor/AccessLogsAvgList'
import accesslogslist from '@/views/monitor/AccessLogsList'
import accesslogsofaction from '@/views/monitor/AccessLogsOfAction'
import accesslogswaitlist from '@/views/monitor/AccessLogsWaitList'
import errorlogs from '@/views/monitor/ErrorLogs'
import analysisCa from '@/views/monitor/analysisCa'

import crowdActiveList from '@/views/crowd/crowdActiveList'
import crowdActiveProductList from '@/views/crowd/crowdActiveProductList'
import crowdConfigList from '@/views/crowd/crowdConfigList'
import crowdFundingForumList from '@/views/crowd/crowdFundingForumList'
import confirmremind from '@/views/cooperative/confirmremind'
import weekJob from '@/views/cooperative/weekJob'
import okr from '@/views/cooperative/OKR'
import kr from '@/views/cooperative/KR'

import reunionproduct from '@/views/reunion/ReunionProduct'
import reunionSite from '@/views/reunion/ReunionSite'
import reunionActive from '@/views/reunion/ReunionActive'
import reunionOrder from '@/views/reunion/ReunionOrder'
import reunionStock from '@/views/reunion/ReunionStock'
import mallDeliverLink from '@/views/deliver/mallDeliverLink'

import productCategory from '@/views/minishop/productCategory'
import brand from '@/views/minishop/brand'
import shopproduct from '@/views/minishop/shopproduct'

import tmallCouponTag from '@/views/taobao/tmallCouponTag'
import activetabs from '@/views/active/activetabs'
import templateScriptConfigList from '@/views/wechat/templateScriptConfigList'
import templateScriptConfigDetail from '@/views/wechat/templateScriptConfigDetail'
import luckydrawList from '@/views/lucky/luckydrawList'
import luckydrawEdit from '@/views/lucky/luckydrawEdit'
import luckydrawUserList from '@/views/lucky/luckydrawUserList'
import luckytabs from '@/views/lucky/luckytabs'
import prizeList from '@/views/lucky/prizeList'
import contactList from '@/views/contact/contactList'
import contactEdit from '@/views/contact/contactEdit'
import matClass from '@/views/aiCall/matClass';
import proPriceList from '@/views/sales/proPriceList';
console.log('----------------')
console.log(productList)
Vue.use(Router)

//解决路由跳转访问相同路径报错 @3.1.x版本
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => console.log(err))
}

let routerVue = new Router({
    routes: [
        {
            path: '',
            name: 'Home',
            component: Home,
            alias:'/home',
            redirect: '/dashboard',
            children:[
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: '/basetable',
                    name: 'BaseTable',
                    component: BaseTable
                },
                {
                    path: '/baseform',
                    name: 'BaseForm',
                    component: BaseForm
                },
                {
                    path: '/quartzList',
                    name: 'QuartzList',
                    component: QuartzList
                },
                {
                    path: '/dictionary',
                    name: 'Dictionary',
                    component: Dictionary
                },
                {
                    path: '/system',
                    name: 'System',
                    component: System
                },
				{
                    path: '/moduleConfig',
                    name: 'ModuleConfig',
                    component: ModuleConfig
				},
                {
                    path: '/indexnavlist',
                    name: 'IndexNavList',
                    component: IndexNavList,
                    meta: {
                        title: "首页配置管理",
                        keepAlive: true
                    },
                },
                {
                    path:'indexnavlist/:indexNavId',
                    name:'IndexItemList',
                    component:IndexItemList
                },
                {
                    path:'pageLinkList',
                    name:'pageLinkList',
                    component:pageLinkList
                },
                {
                    path:'pageLinkList/detail/:id',
                    name:'pageDetail',
                    component:pageDetail
                },
                {
                    path: '/imageList',
                    name: 'ImageList',
                    component: ImageList
                },
                {
                    path: '/cashBath',
                    name: 'CashBath',
                    component: CashBath
                },{
                    path: '/cashBath/detail/:id',
                    name: 'CashBathDetail',
                    component: CashBathDetail
                },
                {
                    path: '/cashSendLog',
                    name: 'cashSendLog',
                    component: cashSendLog
                },
                {
                    path: '/messageConfig',
                    name: 'messageConfig',
                    component: messageConfig
                },
                {
                    path: '/staffConfig',
                    name: 'staffConfig',
                    component: staffConfig
                },
                {
                    path: '/promotionlist',
                    name: 'promotionList',
                    component: promotionList,
                    meta: {
                        title: "促销管理",
                        keepAlive: true
                    },
                },
                {
                    path: '/promotionOrder',
                    name: 'promotionOrder',
                    component: promotionOrder
                },
                {
                    path: '/scrollpic',
                    name: 'scrollpic',
                    component: scrollpic
                },
                {
                    path: '/scrollpic/detail/:id',
                    name: 'scrollpicDetail',
                    component: scrollpicDetail
                },
                {
                    path: '/sysuser',
                    name: 'sysuser',
                    component: sysuser
                },
                {
                    path: '/sysresource',
                    name: 'sysresource',
                    component: sysresource
                },
                {
                    path: '/sysresourcegroup',
                    name: 'sysresourcegroup',
                    component: sysresourcegroup
                },
                {
                    path: '/sysrole',
                    name: 'sysrole',
                    component: sysrole
                },
                {
                    path: '/productlist',
                    beforeEnter(to,from,next){
                        if(from.name != 'ProductList'){
                            next({path:'/productlist/1'})
                        }
                    }
                },
                {
                    path: '/productlist/:id',
                    name: 'ProductList',
                    component: ProductList,
                    meta: {
                        title: "商品管理",
                        keepAlive: true
                    },
                },
                {
                    path: 'productlist/detail/:id',
                    name: 'ProductDetail',
                    component: ProductDetail,
                },
                {
                    path: 'promotionlist/detail/:id',
                    name: 'PromotionDetail',
                    component: PromotionDetail,
                },
                {
                    path: 'productPrice',
                    name: 'productPrice',
                    component: productPrice,
                },
                {
                    path: '*/picture/:id',
                    name: 'ProductPic',
                    component: ProductDic,
                },
                {
                    path: '/grouplist',
                    beforeEnter(to,from,next){
                        if(from.name != 'GroupList'){
                            next({path:'/grouplist/1'})
                        }
                    }
                },
                {
                    path: '/grouplist/:id',
                    name: 'GroupList',
                    component: GroupList,
                    meta: {
                        title: "套装管理",
                        keepAlive: true
                    },
                },
                {
                    path: '/grouplist/detail/:id',
                    name: 'GroupDetail',
                    component: GroupDetail,
                },
                {
                    path: '/cashcreaterule',
                    name: 'cashcreaterule',
                    component: cashcreaterule
                },
                {
                    path: '/password',
                    name: 'password',
                    component: password
                },
                {
                    path: '/wechatKeywordList',
                    name: 'wechatKeywordList',
                    component: wechatKeywordList
                },
                {
                    path: '/wechatKeywordContent',
                    name: 'wechatKeywordContent',
                    component: wechatKeywordContent
                },
                {
                    path: '/wechatKeywordList/detail/:id',
                    name: 'wechatKeywordDetail',
                    component: wechatKeywordDetail
                },
                {
                    path:'/wechatmediaList',
                    name: 'wechatmediaList',
                    component: wechatmediaList
                },
                {
                    path:'/miniCard',
                    name: 'miniCard',
                    component: miniCard
                },
                {
                    path:'/shortlink',
                    name: 'shortlink',
                    component: shortlink
                },{
                    path:'/minilink',
                    name: 'minilink',
                    component: miniLink
                },
                {
                    path:'/wechatBaseList',
                    name:'wechatBaseList',
                    component:wechatBaseList
                },
                {
                    path:'/wechatMenu',
                    name:'wechatMenu',
                    component:wechatMenu
                },
                {
                    path:'/messageLog',
                    name:'messageLog',
                    component:messageLog
                },
                // {
                //     path:'/messageLog/:start/:end/:messageId/:isSuccess',
                //     name:'messageLog1',
                //     component:messageLog
                // },
                {
                    path:'/messageTotalLog',
                    name:'messageTotalLog',
                    component:messageTotalLog
                },
                {
                    path:'/scheme',
                    name:'scheme',
                    component:miniScheme
                },
                {
                    path:'/adSource',
                    name:'adSource',
                    component:adSource
                },
                {
                    path: '/platform',
                    name: 'platform',
                    component: platform
                },
                {
                    path: '/regular',
                    name: 'regular',
                    component: regular
                },
                {
                    path: '/productrelevance',
                    name: 'productrelevance',
                    component: productrelevance
                },
                {
                    path:'/wechatGroupList',
                    name:'wechatGroupList',
                    component:wechatGroupList
                },
                {
                    path:'/wechatTemplateMessageList',
                    name:'wechatTemplateMessageList',
                    component:wechatTemplateMessageList
                },
                {
                    path:'/wechatTemplateMessageContent',
                    name:'wechatTemplateMessageContent',
                    component:wechatTemplateMessageContent
                },
                {
                    path: '/fullcut',
                    name: 'fullcut',
                    component: fullcut,
                    meta: {
                        title: "满减管理",
                        keepAlive: true
                    },
                },
                {
                    path: '/fullcut/detail/:id',
                    name: 'fullcutDetail',
                    component: fullcutDetail
                },
                {
                    path: '/free',
                    name: 'free',
                    component: free
                },
                {
                    path: '/free/detail/:id',
                    name: 'freeEdit',
                    component: freeEdit
                },
                {
                    path:'/shoppingRuleList',
                    name: 'shoppingRuleList',
                    component: shoppingRuleList
                },
                {
                    path:'/vipDay',
                    name: 'vipDay',
                    component: vipDay
                },
                {
                    path:'/vipConditionList',
                    name: 'vipConditionList',
                    component: vipConditionList
                },
                {
                    path:'/vipReward',
                    name: 'vipReward',
                    component: vipReward
                },
                {
                    path:'/vipRight',
                    name: 'vipRight',
                    component: vipRight
                },
                {
                    path:'/vipTask',
                    name: 'vipTask',
                    component: vipTask
                },
                {
                    path:'/vipTaskReward',
                    name: 'vipTaskReward',
                    component: vipTaskReward
                },
                {
                    path:'/vipDaySendLog',
                    name: 'vipDaySendLog',
                    component: vipDaySendLog
                },
                {
                    path:'/discountRange',
                    name: 'discountRange',
                    component: discountRange
                },
                {
                    path:'/mallEvaluate',
                    name: 'mallEvaluate',
                    component: mallEvaluate
                },
                {
                    path:'/mallEvaluateStatistics',
                    name: 'mallEvaluateStatistics',
                    component: mallEvaluateStatistics
                },
                {
                    path:'/mallFreight',
                    name: 'mallFreight',
                    component: mallFreight
                },
                {
                    path:'/coupon',
                    name: 'coupon',
                    component: activeCoupon
                },
                {
                    path:'/collage',
                    name: 'collage',
                    component: collage
                },
                {
                    path:'/collage/productList',
                    name: 'collageProd',
                    component: productList
                },
                {
                    path:'/collageDiscount',
                    name: 'collageDiscount',
                    component: collageDiscount
                },
                {
                    path:'/activeManagement',
                    name: 'activeManagement',
                    component: activeManagement,
                    meta: {
                        title: "活动管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/activeQrMangement',
                    name: 'activeQrMangement',
                    component: activeQrMangement
                },
                {
                    path:'/actvieIndex',
                    name: 'actvieIndex',
                    component: activeIndex
                },
                {
                    path:'/activeProperty',
                    name: 'activeProperty',
                    component: activeProperty
                },
                {
                    path:'/nps',
                    name: 'nps',
                    component: nps
                },
                {
                    path:'/salesNum',
                    name: 'salesNum',
                    component: salesNum
                },
                {
                    path:'/invite',
                    name: 'invite',
                    component: invite
                },
                {
                    path:'/joinList',
                    name: 'joinList',
                    component: joinList
                },
                {
                    path:'/activeRule',
                    name: 'activeRule',
                    component: activeRule
                },
                {
                    path:'/grouponConfig',
                    name: 'grouponConfig',
                    component: grouponConfig
                },
                {
                    path:'/grouponList',
                    name: 'grouponList',
                    component: grouponList
                },
                {
                    path:'/UnsyncOrders',
                    name: 'UnsyncOrders',
                    component: UnsyncOrders
                },
                {
                    path:'/UnsyncedOMSOrders',
                    name: 'UnsyncedOMSOrders',
                    component: UnsyncedOMSOrders
                },
                {
                    path:'/orderRefundFailRecord',
                    name: 'orderRefundFailRecord',
                    component: orderRefundFailRecord
                },
                {
                    path:'/outStock',
                    name: 'outStock',
                    component: outStock
                },
                {
                    path:'/GiftCardBatch',
                    name: 'GiftCardBatch',
                    component: GiftCardBatch
                },
                {
                    path:'/BalanceCardBatch',
                    name: 'BalanceCardBatch',
                    component: BalanceCardBatch
                },
                {
                    path:'/CouponCardBatch',
                    name: 'CouponCardBatch',
                    component: CouponCardBatch
                },
                {
                    path:'/BalanceInventoryRecords',
                    name: 'BalanceInventoryRecords',
                    component: BalanceInventoryRecords
                },
                {
                    path:'/StorageCard',
                    name: 'StorageCard',
                    component: StorageCard
                },
                {
                    path:'/SumDaily',
                    name: 'SumDaily',
                    component: SumDaily
                },
                {
                    path:'/activeReserve',
                    name: 'activeReserve',
                    component: activeReserve,
                    meta: {
                        title: "预约管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/inviteGiftPropert',
                    name: 'inviteGiftPropert',
                    component: inviteGiftPropert,
                    meta: {
                        title: "邀请送礼物",
                        keepAlive: true
                    },
                },
                {
                    path:'/crowdCoupon',
                    name: 'crowdCoupon',
                    component: crowdCoupon
                },
                {
                    path:'/crowdOrder',
                    name: 'crowdOrder',
                    component: crowdOrder
                },
                {
                    path:'/crowd',
                    name: 'crowd',
                    component: crowd
                },
                {
                    path:'/usersystem',
                    name: 'userSystem',
                    component: userSystem,
                    meta: {
                        title: "客户管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/usersystem/detail/:id',
                    name: 'userSystemContent',
                    component: userSystemContent,
                },
                {
                    path:'/queryorder',
                    name: 'queryOrder',
                    component: queryOrder,
                    meta: {
                        title: "订单管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/shipOrder',
                    name: 'shipOrder',
                    component: shipOrder,
                    meta: {
                        title: "发货订单",
                        keepAlive: true
                    },
                },
                {
                    path:'/youShuOrder',
                    name: 'youShuOrder',
                    component: youShuOrder,
                },
                {
                    path:'/orderBill',
                    name: 'orderBill',
                    component: orderBill,
                },
                {
                    path:'/smsSend',
                    name: 'smsSend',
                    component: smsSend
                },
                {
                    path:'/template',
                    name: 'template',
                    component: template
                },
                {
                    path:'/baseApp',
                    name: 'baseApp',
                    component: baseApp
                },
                {
                    path:'/messageGroup',
                    name: 'messageGroup',
                    component: messageGroup
                },
                {
                    path:'/task',
                    name: 'task',
                    component: task
                },
                {
                    path:'/groupRule',
                    name: 'groupRule',
                    component: groupRule
                },
                {
                    path:'/limitMessage',
                    name: 'limitMessage',
                    component: limitMessage
                },
                {
                    path:'/tag',
                    name: 'tag',
                    component: tag
                },
                {
                    path:'task/detail/:id',
                    name: 'TaskEdit',
                    component: TaskEdit
                },

                // {
                //     path:'/prizelist',
                //     name: 'prizeList',
                //     component: prizeList
                // },
                {
                    path:'/alllist',
                    name: 'allList',
                    component: allList
                },
                {
                    path:'/userinterview',
                    name: 'userInterview',
                    component: userInterview
                },
                {
                    path:'/growth',
                    name: 'growth',
                    component: growth
                },
                {
                    path:'/cooperate',
                    name: 'cooperate',
                    component: cooperate
                },{
                    path:'/cooperatePersonal',
                    name: 'cooperatePersonal',
                    component: cooperatePersonal
                },{
                    path:'/quarterkpi',
                    name: 'quarterKpi',
                    component: quarterKpi
                },{
                    path:'/monthreplay',
                    name: 'monthreplay',
                    component: monthReplay
                },{
                    path:'/analysisCa',
                    name: 'analysisCa',
                    component: analysisCa
                },{
                    path:'/weekafterweek',
                    name: 'weekafterweek',
                    component: weekAfterWeek
                },{
                    path:'/interviewinvitation',
                    name: 'interviewinvitation',
                    component: interviewInvitation
                },{
                    path:'/setgrowthinterview',
                    name: 'setGrowthInterview',
                    component: setGrowthInterview
                },
                {
                    path:'/questionclasses',
                    name: 'questionclasses',
                    component: QuestionClasses
                },
                {
                    path:'/periods',
                    name: 'periods',
                    component: Periods
                },
                {
                    path:'/cardOrderPlanLog',
                    name: 'cardOrderPlanLog',
                    component: cardOrderPlanLog
                },
                {
                    path:'/cardOrderPlan',
                    name: 'cardOrderPlan',
                    component: cardOrderPlan
                },
                {
                    path:'/CardBatch',
                    name: 'CardBatch',
                    component: CardBatch,
                    meta: {
                        title: "卡包管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/CardBatch2',
                    name: 'CardBatch2',
                    component: CardBatch2,
                    meta: {
                        title: "卡包管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/CardItem',
                    name: 'CardItem',
                    component: CardItem,
                    meta: {
                        title: "点卡商品管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/shareList',
                    name: 'shareList',
                    component: shareList
                },
                {
                    path:'/orderRefundPayDownload',
                    name: 'orderRefundPayDownload',
                    component: orderRefundPayDownload,
                },
                {
                    path:'/distributorGroup',
                    name: 'distributorGroup',
                    component: distributorGroup
                },
                {
                    path:'/distributor',
                    name: 'distributor',
                    component: distributor
                },
                {
                    path:'/distributorRelation',
                    name: 'distributorRelation',
                    component: distributorRelation
                },
                {
                    path:'/distributionOrder',
                    name: 'distributionOrder',
                    component: distributionOrder
                },
                {
                    path:'/qrcode',
                    name: 'qrcode',
                    component: qrcode,
                    meta: {
                        title: "活码管理",
                        keepAlive: true
                    },
                },
                {
                    path:'/subqrcode',
                    name: 'subqrcode',
                    component: subqrcode
                },
                {
                    path:'/distributorItem',
                    name:'/distributorItem',
                    component:distributorItem
                },
                {
                    path:'/media',
                    name:'/media',
                    component:distributionMedia
                },
                {
                    path:'/mediaStaff',
                    name:'/mediaStaff',
                    component:distributorMedia
                },
                {
                    path:'/siYuLink',
                    name:'/siYuLink',
                    component:siYuLink
                },
                {
                    path:'/distributorLink',
                    name:'/distributorLink',
                    component:distributorLink
                },
                {
                    path:'/qyTag',
                    name:'/qyTag',
                    component:qyTag
                },
                {
                    path:'/corpTagGroup',
                    name:'/corpTagGroup',
                    component:corpTagGroup
                },
                {
                    path:'/corpTagRuleGroup',
                    name:'/corpTagRuleGroup',
                    component:corpTagRuleGroup
                },
                {
                    path:'/tagRule',
                    name:'/tagRule',
                    component:tagRule
                },
                {
                    path:'/offLineShop',
                    name:'/offLineShop',
                    component:offLineShop
                },
                {
                    path:'/salePersonInfo',
                    name:'/salePersonInfo',
                    component:salePersonInfo
                },
                {
                    path:'/accesslogallactions',
                    name:'/accesslogallactions',
                    component:accesslogallactions
                },
                {
                    path:'/accesslogsavglist',
                    name:'/accesslogsavglist',
                    component:accesslogsavglist
                },
                {
                    path:'/accesslogslist',
                    name:'/accesslogslist',
                    component:accesslogslist
                },
                {
                    path:'/accesslogsofaction',
                    name:'/accesslogsofaction',
                    component:accesslogsofaction
                },
                {
                    path:'/accesslogswaitlist',
                    name:'/accesslogswaitlist',
                    component:accesslogswaitlist
                },
                {
                    path:'/errorlogs',
                    name:'/errorlogs',
                    component:errorlogs
                },
                {
                    path:'/crowdActiveList',
                    name: 'crowdActiveList',
                    component: crowdActiveList
                },{
                    path:'/crowdActiveList/:activeNo',
                    name:'crowdActiveProductList',
                    component:crowdActiveProductList,
                    meta: {
                        title: "众筹管理",
                        keepAlive: true
                    },
                },{
                    path:'/crowdConfigList',
                    name: 'crowdConfigList',
                    component: crowdConfigList
                },{
                    path:'/crowdFundingForumList',
                    name: 'crowdFundingForumList',
                    component: crowdFundingForumList
                },{
                    path:'/confirmremind',
                    name: 'confirmremind',
                    component: confirmremind
                },{
                    path:'/weekJob',
                    name: 'weekJob',
                    component: weekJob
                }
                ,{
                    path:'/okr',
                    name: 'okr',
                    component: okr
                },{
                    path:'/kr',
                    name: 'kr',
                    component: kr
                },{
                    path:'/reunionproduct',
                    name: 'reunionproduct',
                    component: reunionproduct
                },{
                    path:'/reunionSite',
                    name: 'reunionSite',
                    component: reunionSite,
                    meta: {
                        title: "站点管理",
                        keepAlive: true
                    },
                },{

                    path:'/reunionActive',
                    name: 'reunionActive',
                    component: reunionActive
                },{

                    path:'/reunionOrder',
                    name: 'reunionOrder',
                    component: reunionOrder
                },{
                      path:'/reunionStock',
                      name: 'reunionStock',
                      component: reunionStock
                },{
                      path:'/tmallCouponTag',
                      name: 'tmallCouponTag',
                      component: tmallCouponTag
                },
                {
                    path:'/mallDeliverLink',
                    name: 'mallDeliverLink',
                    component: mallDeliverLink
                },{
                    path:'/productCategory',
                    name: 'productCategory',
                    component: productCategory
                },{
                    path:'/brand',
                    name: 'brand',
                    component: brand
                },{
                    path:'/shopproduct',
                    name: 'shopproduct',
                    component: shopproduct
                }, {
                    path: '/active/activetabs',
                    name: 'activetabs',
                    component: activetabs
                },{
                    path: '/templateScriptConfigList',
                    name:'templateScriptConfigList',
                    component:templateScriptConfigList,
                    meta: {
                        title: "订阅消息配置",
                        keepAlive: true
                    },
                },{
                    path:'/templateScriptConfigList/detail/:platformId/:id/:pageLinkId',
                    name:'templateScriptConfigDetail',
                    component:templateScriptConfigDetail
                },{
                    path:'/luckydrawList',
                    name:'luckydrawList',
                    component:luckydrawList
                },{
                    path:'/luckydrawEdit',
                    name:'luckydrawEdit',
                    component:luckydrawEdit
                },{
                    path:'/luckydrawUserList',
                    name:'luckydrawUserList',
                    component:luckydrawUserList
                },{
                    path:'/luckytabs',
                    name:'luckytabs',
                    component:luckytabs
                },{
                    path:'/prizeList',
                    name:'prizeList',
                    component:prizeList
                },{
                    path:'/messageBlackList',
                    name:'messageBlackList',
                    component:messageBlackList
                },{
                    path:'/messageBlackEdit',
                    name:'messageBlackEdit',
                    component:messageBlackEdit
                },{
                    path:'/contactEdit',
                    name:'contactEdit',
                    component:contactEdit
                },
                {
                    path:'/contactList',
                    name:'contactList',
                    component:contactList
                },
                {
                    path:'/wordsEdit',
                    name: 'wordsEdit',
                    component: wordsEdit
                },
                {
                    path:'/wordsList',
                    name: 'wordsList',
                    component: wordsList
                },
                {
                    path: '/CardBatchFree/:source/:batchId',
                    name: 'CardBatchFree',
                    component: CardBatchFree,
                    meta: {
                        title: "卡赠品管理",
                        keepAlive: true
                    },
                },{
                    path:'/proPriceList',
                    name: 'proPriceList',
                    component: proPriceList
                },{
                    path:'/matClass',
                    name: 'matClass',
                    component: matClass
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path:'/userInfo',
            name: 'userInfo',
            component: userInfo
        },


    ],
    beforeEach(to,from,next){
        console.log('to=')
        console.log(to)
        console.log('from=')
        console.log(from)
    }
})
export default routerVue



// WEBPACK FOOTER //
// ./src/router/index.js